var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#calendar_svg__clip0_5713_201081)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.234 4.556H3.481v5.634h5.384V7.806h2.369v-3.25zm-3.015 3.25V9.54H6.496V7.806H8.22zm2.369-.65H8.865v-1.95h1.723v1.95zm-2.369 0v-1.95H6.496v1.95H8.22zM4.127 9.54V7.806H5.85V9.54H4.127zM5.85 5.206H4.127v1.95H5.85v-1.95z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.338.727H1.22a.324.324 0 00-.323.325v10.623c0 .18.145.325.323.325h12.06a.324.324 0 00.323-.325V1.052a.324.324 0 00-.323-.325h-1.95V0h-.645v.727H3.984V0h-.646v.727zm7.347 1.437v-.787H3.984v.787h-.646v-.787H1.543v1.415h11.414V1.377H11.33v.787h-.646zM1.543 3.442v7.908h11.414V3.442H1.543z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "calendar_svg__clip0_5713_201081"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.897)",
    d: "M0 0h12.706v12H0z"
  })))));
}
export default SvgCalendar;